import { Component, Input } from '@angular/core';
import { CommentService } from '@service/comment/comment.service';
import { Entity } from '@model/entities/entity';
import { EntityTypeConfig } from '@model/entity-type-config';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { ScrollService } from '@service/scroll.service';
import { StateService } from '@service/state.service';
import { UrlPrettifierService } from '@service/urlPrettifier/url-prettifier.service';

@Component({
  selector: 'comment-button',
  templateUrl: './comment-button.component.html',
  styleUrls: ['./comment-button.component.scss'],
})
export class CommentButtonComponent {
  @Input() public comment_count: number;
  @Input() public hideTextMobile: boolean = false;
  @Input() private entity: Entity = null;

  constructor(
    private commentService: CommentService,
    private entityTypeConfigService: EntityTypeConfigService,
    private scrollService: ScrollService,
    private StateService: StateService,
  ) {
    // count comments +1 when one was written
    this.commentService.commentAddedObservable.subscribe((commentAdded) => {
      if (commentAdded) this.comment_count++;
    });
  }

  public newCommentClicked(event: Event) {
    /*
      If it was given an entity its an outer button.
      So go to entity detail state and then write a comment.
    */
    if (this.entity) {
      event.stopPropagation();

      let entityTypeConfig: EntityTypeConfig = this.entityTypeConfigService.getConfigByEntity(this.entity);

      this.StateService.goto(
        entityTypeConfig.detailstate + '/' + this.entity.id + '/' + UrlPrettifierService.prettyUrl(this.entity.title),
        { scrollToWriteComment: true },
        false,
      );
    } else {
      this.scrollService.scrollToWriteComment();
    }
  }
}
